import React from "react";

//UI Material
import {
  Button,
  Card,
  Grid,
  IconButton,
  Stack,
  SwipeableDrawer,
  Typography,
} from "@mui/material";

//Material Icons
import {
  Add,
  AdminPanelSettings,
  Assignment,
  BarChart,
  Inventory,
  Logout,
  Person,
  ShoppingBag,
  Storage,
  SupportAgent,
  ViewInAr,
} from "@mui/icons-material";

//Logos
import PoweredByElco from "../Logos/PoweredByElco";

function Drawer({ open, setOpen }) {
  //User data from localStorage
  const userData = JSON.parse(localStorage.getItem("userData"));

  //==========> Component functions <==========
  //Function for redirect to Login page
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("password");
    window.location.href = "/";
  };

  //Function to generate buttons according to user role
  const generateButtons = () => {
    return [
      {
        text: "Órdenes de producción",
        icon: <Storage />,
        handleChange: () => {
          window.location.href = "/orders";
        },
        requireAdmin: false,
      },
      {
        text: "Servicio al cliente",
        icon: <SupportAgent />,
        handleChange: () => {
          window.location.href = "/customer-service";
        },
        requireAdmin: true,
      },
      {
        text: "Productos",
        icon: <ShoppingBag />,
        handleChange: () => {
          window.location.href = "/products";
        },
        requireAdmin: true,
      },
      {
        text: "Proveedores",
        icon: <Add />,
        handleChange: () => {
          window.location.href = "/suppliers";
        },
        requireAdmin: true,
      },

      {
        text: "Inventario",
        icon: <Inventory />,
        handleChange: () => {
          window.location.href = "/inventory";
        },
        requireAdmin: true,
      },
      /*
      {
        text: "Proveedores",
        icon: <LocalShipping />,
        handleChange: () => {
          window.location.href = "/suppliers";
        },
        requireAdmin: true,
      },
      {
        text: "Inventario",
        icon: <Inventory />,
        handleChange: () => {
          window.location.href = "/inventory";
        },
        requireAdmin: true,
      },
      {
        text: "Dispositivos",
        icon: <Wifi />,
        handleChange: () => {
          window.location.href = "/connectivity-devices";
        },
        requireAdmin: true,
      },*/

      {
        text: "Producción y ensamblaje",
        icon: <ViewInAr />,
        handleChange: () => {
          window.location.href = "/assembly";
        },
        requireAdmin: false,
      },
      {
        text: "Reportes de producción",
        icon: <BarChart />,
        handleChange: () => {
          window.location.href = "/reports";
        },
        requireAdmin: true,
      },
      {
        text: "Actividades",
        icon: <Assignment />,
        handleChange: () => {
          window.location.href = "/tasks";
        },
        requireAdmin: false,
      },
      {
        text: "Recursos Humanos",
        icon: <AdminPanelSettings />,
        handleChange: () => {
          window.location.href = "/users";
        },
        requireAdmin: true,
      },
    ];
  };

  /**
   * Function to generate the buttons in the drawer
   * @returns the buttons of the drawer menu
   */
  const generateDrawerMenuButtons = () => {
    return generateButtons()
      .filter((button) => {
        if (userData.role === "ADMINISTRATOR") {
          return true;
        }
        return !button.requireAdmin;
      })
      .map((button) => (
        <Button
          size="small"
          key={button.text}
          variant="contained"
          color="secondary"
          sx={{
            color: "white",

            justifyContent: "flex-start",
          }}
          onClick={button.handleChange}
          startIcon={button.icon}
        >
          {button.text}
        </Button>
      ));
  };

  // ==========> Component <==========
  return (
    <SwipeableDrawer
      anchor="left"
      transitionDuration={600}
      disableSwipeToOpen={true}
      open={open}
      sx={{
        zIndex: "99",
        "& .MuiDrawer-paper": {
          justifyContent: "center",
          background: "#000",
        },
      }}
      onClose={() => setOpen(false)}
      onOpen={() => {
        /* empty arrow function */
      }}
    >
      <Grid
        container
        sx={{ p: 2, maxWidth: "550px" }}
        spacing={1}
        alignContent="center"
      >
        <Grid item xs={12}>
          <Card
            raised
            sx={{
              color: "white",
              background: "inherit",
              border: "1px solid #00bccd",
              p: 2,
            }}
          >
            <Stack>
              <Typography fontWeight="bold">{userData.user}</Typography>
              <Typography>{userData.email}</Typography>
              <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems="flex-end"
                spacing={2}
              >
                <IconButton color="secondary" href="/user-account">
                  <Person />
                </IconButton>
                <IconButton color="secondary" onClick={handleLogout}>
                  <Logout />
                </IconButton>
              </Stack>
            </Stack>
          </Card>
        </Grid>
        <Grid item xs={12} sx={{ mt: 2, mb: 2 }}>
          <Stack spacing={2}>{generateDrawerMenuButtons()}</Stack>
        </Grid>
        <Grid item xs={12} align="center">
          <PoweredByElco height="30px" />
        </Grid>
      </Grid>
    </SwipeableDrawer>
  );
}
export default Drawer;
